export const EFFECTS = 1;
export const WAVEFORM = 2;
export const PIANO_ROLL = 3;
